export function tapout(node) {
  function dispatch() {
    node.dispatchEvent(new CustomEvent('tapout'));
  }

  function shouldIgnore(target) {
    if (!target || !target.closest) return false;
    if (target.closest('#app-toolbar')) return true;
    if (target.closest('.context-toolbar')) return true;
    return false;
  }

  function onTouchStart(event) {
    const isInside = Array.from(event.touches).some((touch) => node.contains(touch.target));
    if (!isInside && !shouldIgnore(event.target)) dispatch();
  }

  function onMouseDown(event) {
    if (!node.contains(event.target) && !shouldIgnore(event.target)) dispatch();
  }

  window.addEventListener('touchstart', onTouchStart);
  window.addEventListener('mousedown', onMouseDown);
  return {
    destroy() {
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('mousedown', onMouseDown);
    },
  };
}
